export default __webpack_public_path__ + "static/media/loading.cb5f5e59.gif";